<template>
  <v-card style="min-width:650px;" elevation="0">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white">delete</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span class="text-white text-truncate-popover">Delete "{{ dashModal.bulb.name }}"</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card elevation="0">
      <v-card-text class="mb-1">
        Are you sure you would like to delete "{{ dashModal.bulb.name }}"?
        <v-btn
          flat
          text
          class="branded-text"
          @click="downloadBulbData()"
          >Download Data</v-btn
        >
      </v-card-text>
    </v-card>
    <v-divider></v-divider>
    <v-card-actions class="row-space" style="height:56px">
      <v-btn flat class="branded-grey" @click="setDashModal(null)">Cancel</v-btn>
      <div class="row-center">
        <v-btn
          v-if="dashModal.admin"
          class="branded-background text-white"
          :disabled="!dashModal.admin"
          @click="handleAdminBulbDelete()"
          target="_blank"
        >
          Delete
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
/**
 * Popover modal to confirm an Admin is about to delete a bulb.
 **/
import {
  mapState,
  mapMutations
} from 'vuex';

export default {
  name: 'ConfirmDeleteBulb',
  computed: {
    ...mapState([
      'dashModal',
    ]),
  },
  methods: {
    ...mapMutations([
      'setDashModal',
    ]),
    handleAdminBulbDelete() {
      this.$store.dispatch('instructors/deleteBulb', this.dashModal.bulb.id);
      EventBus.$emit('sendProquestBulbDeletionData', this.dashModal.bulb.id);
      this.setDashModal(null);
    },
    downloadBulbData() {
      this.$store.dispatch('instructors/exportDataTable', {
        type: 'My-Bulbs-BA',
        bulb_id: this.dashModal.bulb.id
      });
    },
  },
};
</script>
